import { getDetailedErrorMessage } from "../../../utils/validation";
export class DmpProvidersFetchFailed extends Error {
    constructor(apiError, fallbackMessage = "Failed to retrieve DMP provider data. Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, DmpProvidersFetchFailed);
        }
        this.name = "DmpProvidersFetchFailed";
        this.message = getDetailedErrorMessage(apiError, fallbackMessage);
        this.apiError = apiError;
        this.fallbackMessage = fallbackMessage;
    }
}
//# sourceMappingURL=errors.js.map